// extracted by mini-css-extract-plugin
export var avatar = "_px-3";
export var avatarContainer = "_px-2";
export var avatarSpacer = "_px-5";
export var avatarSpacerContainer = "_px-4";
export var avatarStackContainer = "_px-1";
export var bubble = "_px-0";
export var remainderBubble = "_px-6";